import { Result, Failure } from "./index";

/**
 * @memberof Result
 */
const isFailure = <E, A>(result: Result<E, A>): result is Failure<E> =>
  result._tag === "Failure";

export default isFailure;
